"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccordionComponents = exports.useAccordion = exports.AccordionContext = void 0;
/* eslint-disable sonarjs/cognitive-complexity */
const react_1 = __importDefault(require("react"));
const Thumbnail_1 = require("../Thumbnail");
exports.AccordionContext = react_1.default.createContext(null);
const useAccordion = (current, accordion, children, accordionId, onPanelChange) => {
    const [activeIndex, setActiveIndex] = react_1.default.useState(current || accordion ? [0] : null);
    react_1.default.useMemo(() => setActiveIndex(current), [current]);
    react_1.default.useMemo(() => (accordion ? setActiveIndex([0]) : setActiveIndex(null)), [accordion]);
    const getContext = react_1.default.useCallback((index) => {
        const changePanel = () => {
            if (accordion) {
                const oldValue = typeof activeIndex === 'number'
                    ? [activeIndex]
                    : activeIndex;
                if (oldValue.includes(index)) {
                    setActiveIndex(oldValue.filter((item) => item !== index));
                }
                else {
                    setActiveIndex(oldValue.length === 0 ? [index] : [...oldValue, index]);
                }
            }
            else {
                setActiveIndex(index);
            }
            onPanelChange === null || onPanelChange === void 0 ? void 0 : onPanelChange(index);
        };
        return {
            index,
            activeIndex,
            accordionId,
            changePanel,
        };
    }, [activeIndex, accordionId]);
    const accordionItems = react_1.default.useCallback(() => {
        return react_1.default.Children.map(children, (child, index) => {
            return (react_1.default.createElement(exports.AccordionContext.Provider, { value: getContext(index) }, child));
        });
    }, [getContext, children]);
    return { accordionItems };
};
exports.useAccordion = useAccordion;
const useAccordionComponents = ({ title, subtitle, components, imageURL, imageALT, }) => {
    const prefix = react_1.default.useMemo(() => {
        return ((components === null || components === void 0 ? void 0 : components.prefix) ||
            (imageURL && react_1.default.createElement(Thumbnail_1.SmThumbnail, { src: imageURL, size: "small", alt: imageALT })));
    }, [imageURL, imageALT, components === null || components === void 0 ? void 0 : components.prefix]);
    const text = react_1.default.useMemo(() => {
        return (title && (react_1.default.createElement("div", { className: "c-accordion__contentText" },
            react_1.default.createElement("span", { className: "c-accordion__title" }, title),
            subtitle && (react_1.default.createElement("span", { className: "c-accordion__subtitle" }, subtitle)))));
    }, [title, subtitle]);
    return { prefix, text };
};
exports.useAccordionComponents = useAccordionComponents;
//# sourceMappingURL=useAccordion.js.map